/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardContent, Container, Divider } from '@mui/material';


const styles = makeStyles(theme => ({
    root: {
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    divinfoNavigation: {
        marginTop: '100px'
    },
    blocksTypoInfo: {
        lineHeight: '2.5em!important',
        color: 'black'
    },
    cardContent: {
    }
}));


const CompanyServices = () => {
    const classes = styles();
    console.log('classes', classes)
    return (
        <>
            <Grid item xs={12} sm={12} md={12}  >
                <Typography variant="h1" align="center" style={{ marginTop: '100px' }} paragraph>
                    Our Services
                </Typography>
                <div className={classes.sectionTitleBorder}></div>
                <div className={classes.divinfoNavigation}>
                    <Container className={classes.cardGrid} maxWidth="lg">
                        {/* End hero unit */}
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6} md={6}>
                                <Card className={classes.cardService} >
                                    <CardContent className={classes.cardContent}>

                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            DIGITAL TRANSFORMATION
                                        </Typography>
                                        <Divider className={classes.divider} style={{ margin: '40px' }} />
                                        <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                            <img src="assets/images/icons/web-analysis.png" width="100px" />
                                        </Typography>
                                        <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                            Throughout our journey we  successfully delivered several projects and
                                            we have acquired the expertise that enables us to  reshape their ideas into final product, going through all the lifecycle,
                                            starting with the definition of project requirements, development phase untill maintenance of the applications.
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Web  Deveopment
                                        </Typography>


                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Mobile  Deveopment
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Digital Strategy
                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            ...
                                        </Typography>
                                        <a href="mailto:info@theraytek.tn" target="_blank" rel="noreferrer" style={{ color: 'black' }}>
                                            <Button variant='contained' className='AlignCenter'  style={{ color: 'black' }}>
                                                Contact us for more information
                                            </Button>
                                        </a>
                                    </CardContent>

                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <Card className={classes.cardService} >
                                    <CardContent className={classes.cardContent}>


                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            CONSULTING
                                        </Typography>
                                        <Divider className={classes.divider} style={{ margin: '40px' }} />
                                        <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                            <img src="assets/images/icons/consultation.png" width="100px" />
                                        </Typography>

                                        <Typography className={classes.blocksTypoInfo} variant="h3" align="center">
                                            Tough decisions requires leadership to develop a consistent strategy which  include
                                            a robust vision,  clear and straight forward goals, and getting the right resources.
                                            Furthermore it requires implementing and delivering the result on time, as expected and on budget.

                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Operational Performance

                                        </Typography>


                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Project Management

                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            Customer Relationship Management

                                        </Typography>
                                        <Typography className={classes.blocksTypo} gutterBottom variant="h2" align="center" color="textPrimary">
                                            ...
                                        </Typography>
                                        <a href="mailto:info@theraytek.tn" target="_blank" rel="noreferrer" style={{ color: 'black' }}>
                                            <Button variant='contained' className='AlignCenter'  style={{ color: 'black' }}>
                                                Contact us for more information
                                            </Button>
                                        </a>
                                    </CardContent>

                                </Card>
                            </Grid>

                        </Grid>
                    </Container>
                </div>
            </Grid>
        </>
    );
}


export default CompanyServices;